import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setTz } from "../lib/api";
import { useAuth } from "../context/AuthContext";

let ctx = null;
const unlock = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch {}
};

export const soundOn = () => localStorage.getItem("mhh_sound") !== "off";

export function chime() {
  if (!ctx || !soundOn()) return;
  [[880, 0], [1320, 0.14]].forEach(([f, t]) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.value = f;
    g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
    g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.35);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + t);
    o.stop(ctx.currentTime + t + 0.4);
  });
}

export default function LiveAlerts() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const after = useRef("");
  useEffect(() => {
    if (user?.timezone) setTz(user.timezone);
    window.addEventListener("pointerdown", unlock, { once: true });
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get("/notifications/poll", { params: { after: after.current } });
        if (!alive) return;
        const fresh = after.current ? data.items : [];
        after.current = data.items.length ? data.items[data.items.length - 1].at : after.current || data.server_time;
        setUser((u) => (u && u.unread_notifications !== data.unread ? { ...u, unread_notifications: data.unread } : u));
        if (!fresh.length) return;
        chime();
        fresh.slice(-3).forEach((n) => {
          toast(n.title, { description: n.body, duration: 8000, action: n.link ? { label: "View", onClick: () => nav(n.link) } : undefined });
          if (document.hidden && "Notification" in window && Notification.permission === "granted") {
            const bn = new Notification(n.title, { body: n.body, icon: "/brand/my_hh_logo_dark.png", tag: n.id });
            bn.onclick = () => { window.focus(); n.link && nav(n.link); };
          }
        });
      } catch {}
    };
    poll();
    const t = setInterval(poll, 5000);
    return () => { alive = false; clearInterval(t); };
  }, [user?.id]); // eslint-disable-line
  return null;
}
